// Angular libraries, then app-routing.module, then services, then components.
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';

// SyncFusion Component Helpers:
import { CheckBoxModule, SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { AccumulationChartModule, ChartAllModule, ChartModule } from '@syncfusion/ej2-angular-charts';
import { AutoCompleteModule, DropDownListModule, ListBoxModule } from '@syncfusion/ej2-angular-dropdowns';
import { GridAllModule, GridModule } from '@syncfusion/ej2-angular-grids';
import { TextBoxModule, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { ProgressButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { DialogModule, TooltipAllModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { NgbModule, NgbCollapseModule} from '@ng-bootstrap/ng-bootstrap';
import { BaseAccordionComponent, BaseGridComponent } from '../components/index';
import { ProgressBarAllModule } from '@syncfusion/ej2-angular-progressbar';

// directives
import { HideByAccessDirective, LabelControl } from '../shared/directives/index';
import { FilterPipe } from '../pipes/filter.pipe';

// RT Shared Components
import { FeatureComponent } from '../components/feature/feature.component';
import { FeatureService } from '../shared/services/feature.service';

@NgModule({
  declarations: [
    BaseAccordionComponent,
    BaseGridComponent,
    HideByAccessDirective,
    LabelControl,
    FilterPipe,
    FeatureComponent
  ],
  imports: [
    ProgressBarAllModule,
    ProgressButtonModule,
    ToastrModule.forRoot({
      timeOut: 8000,
      preventDuplicates: true,
      positionClass: 'toast-top-center'
    })
  ],
  providers: [
    FeatureService
  ],
  exports: [
    CommonModule,
    ToastrModule,
    CheckBoxModule,
    SwitchModule,
    TextBoxModule,
    UploaderModule,
    DialogModule,
    GridModule,
    DropDownListModule, GridAllModule,
    AccordionModule,
    TooltipModule,
    TooltipAllModule,
    AutoCompleteModule,
    ChartModule,
    ChartAllModule,
    AccumulationChartModule,
    ListBoxModule,
    NgbCollapseModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    BaseAccordionComponent,
    BaseGridComponent,
    FilterPipe,
    HideByAccessDirective,
    LabelControl,
    ProgressBarAllModule,
    FeatureComponent
  ]
})
export class AppSharedModule { }
